import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUnitApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getUnitListApi = createAsyncThunk('getUnitList', async (payload) => {
  // console.log('payload', payload);
  return await getUnitApi(payload);
});

const getUnitListSlice = createSlice({
  name: 'getUnitList', // Unique Name
  initialState,
  reducers: {
    getUnitListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUnitListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getUnitListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getUnitListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getUnitListReset } = getUnitListSlice.actions;

export default getUnitListSlice.reducer;
